import React from "react";
import "./About.css";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import AboutSection1 from "../../components/AboutSection1/AboutSection1";

export default function About() {
  return (
    <>
      {/* Render the CommonBanner component with the bannerText prop */}
      <CommonBanner bannerText="About ApisChain" />
      
      {/* Render a div with a class 'honeycomb' for some custom styling */}
      <div className="honeycomb"></div>
      
      {/* Render the main content inside a container, with the AboutSection1 component */}
      <div className="container">
        <AboutSection1 />
      </div>
    </>
  );
}
